<template>
  <div>
    <div class="tools2">
      <a-button class="toolsbtn" title="放大" @click="mousetype('zoomIn')">
        <a-icon type="zoom-in" />
      </a-button>
      <a-button class="toolsbtn" title="缩小" @click="mousetype('zoomOut')">
        <a-icon type="zoom-out" />
      </a-button>
      <a-button class="toolsbtn" title="返回" @click="comeback">
        <a-icon type="rollback" />
      </a-button>
    </div>

    <div class="maxbox" @keyup.enter="changMinimg($event)">
      <a-spin :spinning="isloading">
        <div id="bigbox">
          <div id="tagInBox">
            <img :src="imgurl" alt="" ref="img" class="canvas-img" />
            <canvas
              id="mycanvas"
              ref="mycanvas"
              width="1200"
              height="600"
              @mousedown="canvasdown"
              @mousemove="canvasmove"
              @dblclick="dbcanvas"
              @mouseup="canvasup"
            >
            </canvas>
          </div>
        </div>
      </a-spin>

      <div style="display: flex;margin-right:90px;">
        <div class="box2">
          <a-button title="上一页" @click.native="toup">
            <a-icon type="up" />
          </a-button>
          <a-spin :spinning="isloading">
          <div class="imgList">
            <div
              :class="['minimgbox', { borderColor: borderColor == index }]"
              v-for="(item, index) in imgList"
              :key="item.imagePath"
              @click="handlerImg(item, index)"
            >
              <img :src="buildimgpath(item)" class="minimg" ref="minimg" />
            </div>
          </div>
          </a-spin>
          <a-button title="下一页" @click.native="todown">
            <a-icon type="down" />
          </a-button>
        </div>
      </div>

    </div>

    
    <div class="imgtext">
      {{ this.imgtext }}
    </div>
    

  </div>
</template>

<script>
import { requestUrl } from "@utils/request_url";
import { getMarkImageInfoApi } from '@api/semi_management';
export default {
  props: {
    // 图片id
    id: {
      type: Number,
      default: 0,
    },
    // 第几张图片的下标
    Colorindex: {
      type: Number,
      default: 0,
    },
    /**
     * 分页  切换是否上一页或者下一页传参
     */
    pageIndex: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 16,
    },
    /**
     *  文件夹id
     */
    filePathId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      labelCol: { span: 0 }, //组件的排版布局
      wrapperCol: { span: 24 }, //组件的排版布局
      fileId: 0, //图片的id
      imgList: [], //请求一组图片的数据
      borderColor: 0, //选中小图的下标，也是当前canvas的图片信息在一组图片的下标
      imgurl: "", //当前图片的路径
      imgtext: "", //当前图片的名字

      allPage:0,
      queryImageParam: {
        pageSize: 12,
        pageIndex: 1,
        param: "",
        resourceId:"",
        flag:1,
      },
      minimage: [], //下方的小的图片列表
      isloading: false, //判断是否在加载，显示加载效果
      shapes: [], //记录在图片上的多个多边形的数据
      operaType: "none", //canvas点击时的一种状态 
      isclcikMinImg: false,

      status: 0, //移动多边形的状态
      dotstatus: 0, //多边形点的状态，分为0,1,2。当为0时不发生拖拽效果，当为1时为确定是哪个点，为2时是拖拽这个点



      movedotposition: {}, //选中拖拽的点
      dotmove: false, //判断是否要移动，通过点击多边形的顶点来触发
      
      preventclick: true, //防止点击多边形但不拖拽的变量
      newpositionarr: [], //确定多边形，拖拽时要删除这个多边形并且加上这个多边形的位置信息，让canvas重绘，这个就是新的多边形顶点坐标数组
      movepolygnarr: [], //确定的移动的多边形
      
      selectIndex: 0, //选中第几个多边形的下标
      notkeepArr: [], //没有保存标注的img的名字会记录在上面，提示用户哪些没有保存
      
      scalenumber: 1, //放大或者缩小的倍数
      // can_height: 0,
      // can_width: 0,
      tempWidth: 0, //缩放的宽度比例
      tempHeight: 0, //缩放的高度比例
      canvas: null, //canvas的dom元素
      ctx: null, //canvas2d操作
      image: null, //图片的dom元素
      // number: 1,
      imgoffsetleft: 0, //图片的相对左边的位置
      imgoffsettop: 0, //图片的相对上边的位置
      
      polygon: [], //多边形顶点的左边数组
      isPointAdd: false, //判断是否要画点，多边形的顶点
      isDrawing: false, //判断是否在绘制
      polygons: [], //多个多边形的顶点信息数组[[],[]] 形式
      realpositions: [], //真实的点的坐标，等比压缩后会时原来的点的坐标也等比压缩
     
     
      requestUrl: requestUrl, //图片的基础路径
      leftNum: 0, //小图列表的移动个数
      
      // colorid: 0,
      // isshowmark: true,
      
      
      pt: null, //点击多边形时的鼠标位置，从而判断点是否在多边形上
     
      islock: false,
    };
  },
  created() {
     this.borderColor = this.Colorindex;
     this.fileId = this.id;
     this.queryImageParam.pageIndex = this.pageIndex;
     this.queryImageParam.pageSize = this.pageSize;
     this.queryImageParam.resourceId = this.filePathId;
     this.init();
  },
  mounted() {
    this.canvas = document.getElementById("mycanvas");
    this.ctx = this.canvas.getContext("2d");
    this.ctx.strokeStyle = "red";
    this.ctx.fillStyle = "red";
    this.ctx.lineWidth = "3";
    this.ctx.font = "30px Arial";
    this.ctx.save();
  },
  methods: {

    //页面初始化
    async init(){
        this.isloading = false;
        let res = await getMarkImageInfoApi(this.queryImageParam);
        this.imgList = res.data.list;
        this.allPage = res.data.totalPages;
        let showData = this.imgList[this.borderColor];
        this.imgtext = showData.fileName;
        this.imgurl = this.requestUrl + showData.imagePath.replace(/#/g, '%23');
        this.shapes = showData.shapes;
        this.mark();

        this.$nextTick(() => {
           this.initimg();
           this.initminimg();
        });
    },
    /**
     * 标注展示
     */
    mark(){
      for (let i = 0; i < this.shapes.length; i++) {
          const minarr = [];
          const obj = {};
          for (let j = 0; j < this.shapes[i].points.length; j++) {
            if (
                !obj[this.shapes[i].points[j].x] ||
                !obj[this.shapes[i].points[j].y]
              ) {
                minarr.push(this.shapes[i].points[j]);
                obj[this.shapes[i].points[j].x] = true;
                obj[this.shapes[i].points[j].y] = true;
              }
            }
          this.shapes[i].points = minarr;
        }
    },

    // 返回图片的真实路径
    buildimgpath(item) {
      var img = "";
      if (item.thumbFileName != null) {
        img = item.thumbFileName.replace(/#/g, '%23');
      } else {
        img = item.imagePath.replace(/#/g, '%23');
      }
      return this.requestUrl + img;
    },

    // 初始化图片让图片等比缩放
    initimg() {
      this.image = this.$refs.img;
      const that = this;
      this.$refs.img.onload = function () { 
        const widthscale = that.imgList[that.borderColor].imageWidth;
        const heightscale = that.imgList[that.borderColor].imageHeight;
        const scale = that.image.width / that.image.height;
        if (that.image.width > that.image.height) {
          if (that.image.width > 1250) {
            if (1250 / scale > 750) {
              that.image.style.height = "750px";
              that.image.style.width = `${scale * 750}px`;
            } else {
              that.image.style.width = "1250px";
              that.image.style.height = `${1250 / scale}px`;
            }
          } else {
            if (that.image.height > 750) {
              that.image.style.height = "750px";
              that.image.style.width = `${scale * 750}px`;
            } else {
              that.image.style.height = that.image.height + "px";
              that.image.style.width = that.image.width + "px";
            }
          }
        } else {
          if (that.image.height > 750) {
            that.image.style.height = "750px";
            that.image.style.width = `${scale * 750}px`;
          } else {
            that.image.style.height = that.image.height + "px";
            that.image.style.width = that.image.width + "px";
          }
        }
        that.tempWidth = widthscale / parseInt(that.image.style.width);
        that.tempHeight = heightscale / parseInt(that.image.style.height);
        that.fixedcanvas();
      };
    },
     // 初始化小图片列表等比缩放
    initminimg() {
      this.minimage = this.$refs.minimg;
      const that = this;
      for (let i = 0; i < this.minimage.length; i++) {
        this.minimage[i].onload = function () {
          const width = that.minimage[i].width;
          const height = that.minimage[i].height;
          const scale = width / height;
          if (width > height) {
            if (width > 90) {
              if (90 / scale > 90) {
                that.minimage[i].style.height = "90px";
                that.minimage[i].style.width = `${scale * 90}px`;
              } else {
                that.minimage[i].style.width = "90px";
                that.minimage[i].style.height = `${90 / scale}px`;
              }
            } else {
              if (that.minimage[i].height > 90) {
                that.minimage[i].style.height = "90px";
                that.minimage[i].style.width = `${scale * 90}px`;
              }
            }
          } else {
            if (that.minimage[i].height > 90) {
              that.minimage[i].style.height = "90px";
              that.minimage[i].style.width = `${scale * 90}px`;
            }
          }
        };
      }
    },
    // 点击切换小图片，再将图片的标注信息重新赋值
    handlerImg(item, index) {
      this.borderColor = index;
      this.shapes = this.imgList[this.borderColor].shapes ? this.imgList[this.borderColor].shapes : [];
      this.mark();
      this.imgtext = item.fileName;
      var img = this.requestUrl + item.imagePath
      this.imgurl = img.replace(/#/g, '%23');
      this.fileId = item.fileId;
      this.operaType = "none";
      this.status = 0;
      this.dotstatus = 0;
      this.isclcikMinImg = true;
    },
    // 点击下一页
    todown() {
      this.queryImageParam.pageIndex++;
      if (this.queryImageParam.pageIndex > this.allPage) {
        this.queryImageParam.pageIndex--;
        return this.$message.warning("后面没有了，请换另一个资源", 1);
      } else {
        const that = this;
        this.islock = true;
        this.$confirm({
          title: "切换下一页",
          content: "是否切换到下一页？",
          okText: "是",
          cancelText: "否",
          onOk() {
            that.borderColor=0;
            that.init();
            that.$message.warning(`第${that.queryImageParam.pageIndex}页`, 1);
            that.islock = false;
            that.isclcikMinImg = false;
          },
          onCancel() {
            that.queryImageParam.pageIndex--;
            that.islock = false;
          },
        });
      }
    },
    // 点击上一页
    toup() {
      this.queryImageParam.pageIndex--;
      if (this.queryImageParam.pageIndex < 1) {
        this.queryImageParam.pageIndex++;
        return this.$message.warning("前面没有了，请换另一个资源", 1);
      } else {
        const that = this;
        this.islock = true;
        this.$confirm({
          title: "切换上一页",
          content: "是否切换到上一页？",
          okText: "是",
          cancelText: "否",
          onOk() {
            that.borderColor = 0;
            that.init();
            that.$message.warning(`第${that.queryImageParam.pageIndex}页`, 1);
            that.islock = false;
            that.isclcikMinImg = false;
          },
          onCancel() {
            that.queryImageParam.pageIndex++;
            that.islock = false;
          },
        });
      }
    },

    // 将canvas完美的覆盖在压缩的图片上方
    fixedcanvas() {
      this.imgoffsetleft = this.image.offsetLeft;
      this.imgoffsettop = this.image.offsetTop;
      this.canvas.style.left = this.imgoffsetleft + "px";
      this.canvas.style.top = this.imgoffsettop + "px";
      this.canvas.width = parseInt(this.image.style.width);
      this.canvas.height = parseInt(this.image.style.height);
      this.initmarkimg();
    },
    // 初始化图片标注，重绘加初始化标注，产生多边形移动和拖拽顶点的效果
    initmarkimg() {
      let item = this.imgList[this.borderColor];
      if (item.shapes != null) {
        for (let i = 0; i < item.shapes.length; i++) {
          this.ctx.beginPath();
          this.ctx.moveTo(
            item.shapes[i].points[0].x / this.tempWidth,
            item.shapes[i].points[0].y / this.tempHeight
          );
          for (let j = 1; j < item.shapes[i].points.length; j++) {
            this.ctx.lineTo(
              item.shapes[i].points[j].x / this.tempWidth,
              item.shapes[i].points[j].y / this.tempHeight
            );
          }
          this.ctx.closePath();
          this.ctx.strokeStyle = "#FF0000";
          this.ctx.fillStyle = "rgba(100,0,0,0.3)";
          this.ctx.fill();
          this.ctx.stroke();
          this.ctx.font = "14px Arial";
          const distenceWidth =
            item.shapes[i].points[item.shapes[i].points.length - 1].x /
            this.tempWidth;
          const distenceHeight =
            item.shapes[i].points[item.shapes[i].points.length - 1].y /
            this.tempHeight;
          if (distenceHeight < 15 && distenceWidth > this.canvas.width - 40) {
            this.ctx.strokeText(
              `${item.shapes[i].label}`,
              distenceWidth - 40,
              distenceHeight + 15
            );
          } else if (
            distenceHeight > this.canvas.height - 15 &&
            distenceWidth > this.canvas.width - 40
          ) {
            this.ctx.strokeText(
              `${item.shapes[i].label}`,
              distenceWidth - 40,
              distenceHeight - 15
            );
          } else if (distenceHeight < 15) {
            this.ctx.strokeText(
              `${item.shapes[i].label}`,
              distenceWidth,
              distenceHeight + 15
            );
          } else if (distenceHeight > this.canvas.height - 15) {
            this.ctx.strokeText(
              `${item.shapes[i].label}`,
              distenceWidth,
              distenceHeight - 15
            );
          } else if (distenceWidth > this.canvas.width - 40) {
            this.ctx.strokeText(
              `${item.shapes[i].label}`,
              distenceWidth - 40,
              distenceHeight
            );
          } else {
            this.ctx.strokeText(
              `${item.shapes[i].label}`,
              distenceWidth,
              distenceHeight
            );
          }
        }
      }
    },
    // 放大的效果
    scale(type) {
      this.status = 0;
      this.dotstatus = 0;
      const box = document.getElementById("tagInBox");
      if (type == "zoomIn") {
        this.scalenumber += 0.2;
        box.style.transform = "scale(" + this.scalenumber + ")";
      } else {
        this.scalenumber -= 0.2;
        box.style.transform = "scale(" + this.scalenumber + ")";
        if (this.scalenumber < 0) {
          this.scalenumber = 0;
        }
      }
    },
 
    // 点击不同的按钮出发不同的点击事件
    mousetype(type) {
      this.operaType = type;
      switch (type) {
        case "zoomIn":
          this.scale(type);
          break;
        case "zoomOut":
          this.scale(type);
          break;
        // case "reset":
        //   this.reset();
        //   break;
        // case "dian":
        //   this.huadian();
        //   break;
        // case "toRight":
        //   this.rotateOpera(type);
        //   break;
        // case "toLeft":
        //   this.rotateOpera(type);
        //   break;
        // case "download":
        //   this.downloadIamge(this.imgUrl, new Date().getTime());
        //   break;
      }
    },
    // 点击返回出发的效果
    comeback() {
      this.$emit("changeismark",this.filePathId);
    },
    // canvas的点击事件
    canvasdown(e) {
      if (
        this.operaType == "zoomIn" ||
        this.operaType == "zoomOut" ||
        this.operaType == "none"
      ) {
        this.status = 0;
        this.dotstatus = 0;
        const box = document.getElementById("tagInBox");
        const bigbox = document.getElementById("bigbox");
        var distanceX = e.clientX - box.offsetLeft;
        var distanceY = e.clientY - box.offsetTop;
        box.onmousemove = function (ev) {
          var oevent = ev;
          box.style.left = oevent.clientX - distanceX + "px";
          box.style.top = oevent.clientY - distanceY + "px";
        };
        bigbox.onmouseleave = function () {
          box.onmousemove = null;
        };
        box.onmouseup = function () {
          box.onmousemove = null;
        };
      }
      if (this.operaType == "dian") {
        this.status = 0;
        this.dotstatus = 0;
        this.dotmove = false;
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.initmarkimg();
        this.huaxian(e);
       
      }
      if (
        this.operaType == "choose" ||
        this.operaType == "move" ||
        this.operaType == "del" ||
        this.operaType == "drafting"
      ) {
        this.choose(e, this);
      }
      if (this.dotstatus == 2) {
        this.canvas.style.cursor = "pointer";
        console.log(this.selectIndex);
        this.dotmove = true;
        this.movedotposition = {
          x: e.offsetX,
          y: e.offsetY,
        };
        console.log(this.movedotposition);
      }
    },
    // 选择多边形，并判断点击的状态来完成不同的操作
    choose(e, that) {
      this.pt = {
        x: e.offsetX,
        y: e.offsetY,
      };
      const polys = [];
      that.shapes.forEach((v) => {
        const poly = [];
        v.points.forEach((p) => {
          var position = {};
          position.x = p.x / that.tempWidth;
          position.y = p.y / that.tempHeight;
          poly.push(position);
        });
        polys.push(poly);
      });
      for (let index = 0; index < polys.length; index++) {
        var currentPoly = polys[index];
        var r = that.pointInPoly(this.pt, currentPoly);
        if (r) {
          that.selectIndex = index;
          break;
        }
      }
      that.ctx.strokeStyle = "blue";
      that.ctx.beginPath();
      that.ctx.moveTo(
        that.shapes[that.selectIndex].points[0].x / that.tempWidth,
        that.shapes[that.selectIndex].points[0].y / that.tempHeight
      );
      for (let i = 1; i < that.shapes[that.selectIndex].points.length; i++) {
        that.ctx.lineTo(
          that.shapes[that.selectIndex].points[i].x / that.tempWidth,
          that.shapes[that.selectIndex].points[i].y / that.tempHeight
        );
      }
      that.ctx.closePath();
      that.ctx.stroke();
      if (this.operaType == "move" && r) {
        this.dotstatus = 0;
        that.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        that.initmarkimg();
        that.rewrite(polys);
        that.movepolygnarr = that.shapes[that.selectIndex].points;
        // 去重
        const arr = [];
        const obj = {};
        for (let i = 0; i < that.movepolygnarr.length; i++) {
          if (!obj[that.movepolygnarr[i].x] || !obj[that.movepolygnarr[i].y]) {
            arr.push(that.movepolygnarr[i]);
            obj[that.movepolygnarr[i].x] = true;
            obj[that.movepolygnarr[i].y] = true;
          }
        }
        that.movepolygnarr = arr;
        that.recordpolygn = that.shapes[that.selectIndex];
        that.shapes.splice(this.selectIndex, 1);
        that.preventclick = true;
        that.status = 1;
      }
      if (this.operaType == "del" && r) {
        this.delpolygon();
      }
      if (this.operaType == "drafting" && r) {
        that.movepolygnarr = that.shapes[that.selectIndex].points;
        // 去重
        const arr = [];
        const obj = {};
        for (let i = 0; i < that.movepolygnarr.length; i++) {
          if (!obj[that.movepolygnarr[i].x] || !obj[that.movepolygnarr[i].y]) {
            arr.push(that.movepolygnarr[i]);
            obj[that.movepolygnarr[i].x] = true;
            obj[that.movepolygnarr[i].y] = true;
          }
        }
        that.movepolygnarr = arr;
        this.drawDot2(that.movepolygnarr);
      }
    },
    // 点击后重新绘制标注
    rewrite(polys) {
      const that = this;
      for (let index = 0; index < polys.length; index++) {
        let currentPoly = polys[index];
        let r = that.pointInPoly(this.pt, currentPoly);
        if (r) {
          that.selectIndex = index;
          break;
        }
      }
      that.ctx.strokeStyle = "blue";
      that.ctx.beginPath();
      that.ctx.moveTo(
        that.shapes[that.selectIndex].points[0].x / that.tempWidth,
        that.shapes[that.selectIndex].points[0].y / that.tempHeight
      );
      for (let i = 1; i < that.shapes[that.selectIndex].points.length; i++) {
        that.ctx.lineTo(
          that.shapes[that.selectIndex].points[i].x / that.tempWidth,
          that.shapes[that.selectIndex].points[i].y / that.tempHeight
        );
      }
      that.ctx.closePath();
      that.ctx.stroke();
    },
    // 判断点是否在多边形的算法
    pointInPoly(pt, poly) {
      for (var c = false, i = -1, l = poly.length, j = l - 1; ++i < l; j = i)
        ((poly[i].y <= pt.y && pt.y < poly[j].y) ||
          (poly[j].y <= pt.y && pt.y < poly[i].y)) &&
          pt.x <
            ((poly[j].x - poly[i].x) * (pt.y - poly[i].y)) /
              (poly[j].y - poly[i].y) +
              poly[i].x &&
          (c = !c);
      return c;
    },

    // 绘画多边形的顶点
    drawDot(loc) {
      this.ctx.beginPath();
      this.ctx.arc(loc.x, loc.y, 0.5, 0, 2 * Math.PI);
      this.ctx.restore();
      this.ctx.fillStyle = "red";
      this.ctx.fill();
    },
    // 绘画多边形的线
    drawLine(locStart, locEnd) {
      this.ctx.strokeStyle = "red";
      this.ctx.beginPath();
      this.ctx.moveTo(locStart.x, locStart.y);
      this.ctx.lineTo(locEnd.x, locEnd.y);
      this.ctx.stroke();
      this.ctx.fill();
    },
    // 画多边形
    drawPolygon(points) {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.fillcanvas();
      this.initmarkimg();
      const length = this.polygon.length;
      //单数要多画一个点，双数就是画点和线
      for (let i = 0; i < parseInt(length / 2); i++) {
        this.drawDot(points[i * 2]);
        this.drawLine(points[i * 2], points[i * 2 + 1]);
      }
      if (points.length % 2 === 1) {
        this.drawDot(points[length - 1]);
      }
      if (points.length > 2) {
        // console.log("close");
        this.drawLine(points[length - 1], points[0]);
      }
    },
    // 计算鼠标的新位置与 原来位置的相对位置，让多边形的顶点也随之变化
    distance(oldp, newp) {
      return {
        x: oldp.x - newp.x,
        y: oldp.y - newp.y,
      };
    },
    // canvas的移动事件
    canvasmove(e) {
      if (this.isDrawing) {
        const loc = {
          x: e.offsetX,
          y: e.offsetY,
        };
        if (!this.isPointAdd) {
          this.polygon.pop();
        }
        this.polygon.push(loc);
        this.isPointAdd = false;
        this.drawPolygon(this.polygon);
      }
      if (this.status == 1) {
        let newpositionarr1 = [];
        let newposition = {
          x: e.offsetX,
          y: e.offsetY,
        };
        let distencePosition = this.distance(this.pt, newposition);
        if (
          Math.abs(distencePosition.x) > 1 ||
          Math.abs(distencePosition.y) > 1
        ) {
          this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
          this.ctx.beginPath();
          this.ctx.moveTo(
            this.movepolygnarr[0].x / this.tempWidth - distencePosition.x,
            this.movepolygnarr[0].y / this.tempHeight - distencePosition.y
          );
          newpositionarr1.push({
            x: this.movepolygnarr[0].x / this.tempWidth - distencePosition.x,
            y: this.movepolygnarr[0].y / this.tempHeight - distencePosition.y,
          });
          for (let i = 1; i < this.movepolygnarr.length; i++) {
            this.ctx.lineTo(
              this.movepolygnarr[i].x / this.tempWidth - distencePosition.x,
              this.movepolygnarr[i].y / this.tempHeight - distencePosition.y
            );
            newpositionarr1.push({
              x: this.movepolygnarr[i].x / this.tempWidth - distencePosition.x,
              y: this.movepolygnarr[i].y / this.tempHeight - distencePosition.y,
            });
          }
          this.ctx.closePath();
          this.ctx.stroke();
          this.ctx.fillStyle = "rgba(100,0,0,0.3)";
          this.ctx.fill();
          this.ctx.strokeText(
            `${this.recordpolygn.label}`,
            this.movepolygnarr[this.movepolygnarr.length - 1].x /
              this.tempWidth -
              distencePosition.x,
            this.movepolygnarr[this.movepolygnarr.length - 1].y /
              this.tempHeight -
              distencePosition.y
          );
          this.initmarkimg();
          this.newpositionarr = newpositionarr1;
          this.preventclick = false;
        }
      }

      if (this.dotstatus == 1) {
        // 判断鼠标是否在点上
        const mouseposition = {
          x: e.offsetX,
          y: e.offsetY,
        };
        const that = this;
        for (let i = 0; i < that.movepolygnarr.length; i++) {
          if (
            Math.sqrt(
              Math.pow(
                that.movepolygnarr[i].x / that.tempWidth - mouseposition.x,
                2
              ) +
                Math.pow(
                  that.movepolygnarr[i].y / that.tempHeight - mouseposition.y,
                  2
                )
            ) < 6
          ) {
            that.canvas.style.cursor = "pointer";
            console.log(111);
            this.dotstatus = 2;
            console.log(this.dotstatus);
            this.movedotnum = i;
            break;
          } else {
            this.operaType = "move";
          }
        }
      } else {
        this.canvas.style.cursor = "default";
      }
      if (this.dotstatus == 2 && this.dotmove == false) {
        // 判断鼠标是否在点上
        const mouseposition = {
          x: e.offsetX,
          y: e.offsetY,
        };
        const that = this;
        for (let b = 0; b < that.movepolygnarr.length; b++) {
          if (
            Math.sqrt(
              Math.pow(
                that.movepolygnarr[b].x / that.tempWidth - mouseposition.x,
                2
              ) +
                Math.pow(
                  that.movepolygnarr[b].y / that.tempHeight - mouseposition.y,
                  2
                )
            ) < 6
          ) {
            that.canvas.style.cursor = "pointer";
            this.dotstatus = 2;
            this.movedotnum = b;
            break;
          }
        }
      }
      if (this.dotstatus == 2 && this.dotmove == true) {
        let position = {
          x: e.offsetX * this.tempWidth,
          y: e.offsetY * this.tempHeight,
        };

        this.imgList[this.borderColor].shapes[this.selectIndex].points.splice(
          this.movedotnum,
          1,
          position
        );
        this.canvas.style.cursor = "pointer";
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        this.initmarkimg();
        if (!this.notkeepArr.includes(this.imgtext)) {
          this.notkeepArr.push(this.imgtext);
        }
      }
    },
    // canvas的双击事件
    dbcanvas() {
      if (this.isDrawing) {
        // this.ctx.restore()
        this.ctx.fillStyle = "red";
        this.ctx.fill();
        this.drawPolygon(this.polygon);
        this.polygons.push(this.polygon);
        this.fillcanvas();
        this.isDrawing = false;
        // this.operaType = "none";
      }
    },
    // canvas的鼠标抬起事件，在这里清除状态
    canvasup() {
      if (this.status == 1) {
        this.status = 0;
        if (this.preventclick) {
          this.shapes.push(this.recordpolygn);
          this.operaType = "drafting";
        } else {
          for (let i = 0; i < this.newpositionarr.length; i++) {
            this.newpositionarr[i].x =
              this.newpositionarr[i].x * this.tempWidth;
            this.newpositionarr[i].y =
              this.newpositionarr[i].y * this.tempHeight;
          }
          this.recordpolygn.points = this.newpositionarr;
          this.shapes.push(this.recordpolygn);
          this.newpositionarr = [];
          this.operaType = "drafting";
          if (!this.notkeepArr.includes(this.imgtext)) {
            this.notkeepArr.push(this.imgtext);
          }
        }
      }
      if (this.dotstatus == 2 && this.dotmove == true) {
        this.dotstatus = 1;
        this.dotmove = false;
        this.canvas.style.cursor = "default";
        this.movepolygnarr =
          this.imgList[this.borderColor].shapes[this.selectIndex].points;
        this.drawDot2(
          this.imgList[this.borderColor].shapes[this.selectIndex].points
        );
        // this.operaType = 'none'
      }
    },
    // 画多边形后填充多边形
    fillcanvas() {
      // for (let i = 0; i < this.polygons.length; i++) {
      this.ctx.beginPath();
      this.ctx.moveTo(this.polygon[0].x, this.polygon[0].y);
      for (let j = 0; j < this.polygon.length; j++) {
        this.ctx.lineTo(this.polygon[j].x, this.polygon[j].y);
      }
      this.ctx.fillStyle = "rgba(100,0,0,0.3)";
      this.ctx.fill();
      // }
    },
    // 显示多边形
    showshapes() {
      for (let i = 0; i < this.shapes.length; i++) {
        this.ctx.beginPath();
        this.ctx.moveTo(
          this.shapes[i].points[0].x / this.tempWidth,
          this.shapes[i].points[0].y / this.tempHeight
        );
        for (let j = 1; j < this.shapes[i].points.length; j++) {
          this.ctx.lineTo(
            this.shapes[i].points[j].x / this.tempWidth,
            this.shapes[i].points[j].y / this.tempHeight
          );
        }
        this.ctx.fillStyle = "rgba(100,0,0,0.3)";
        this.ctx.fill();
      }
    },
    // 返回真实的点的坐标
    positions() {
      // this.positions = [...this.polygons]
      // console.log(this.positions);
      // const positions = [...this.polygons]
      const manypositions = [];
      for (let i = 0; i < this.polygons.length; i++) {
        let positions = [];
        let obj = {};
        for (let j = 0; j < this.polygons[i].length; j++) {
          let position = {};
          if (!obj[this.polygons[i][j].x] || !obj[this.polygons[i][j].y]) {
            position.x = parseFloat(
              (this.polygons[i][j].x * this.tempWidth).toFixed(2)
            );
            position.y = parseFloat(
              (this.polygons[i][j].y * this.tempHeight).toFixed(2)
            );
            positions.push(position);
            obj[this.polygons[i][j].x] = true;
            obj[this.polygons[i][j].y] = true;
          }

          // console.log(111);
        }
        // this.polygons[i].forEach(item => {
        //     let position = {}
        //     position.x = item.x*this.tempWidth
        //     position.y = item.y*this.tempWidth
        //     positions.push(position)
        //     console.log(1);
        // });
        manypositions.push(positions);
      }
      this.realpositions = manypositions;
      console.log(this.realpositions);
    },
    // 开始画多边形
    huaxian(e) {
      if (this.tags == "") {
        this.$message.error("没有添加标签，请添加标签后再标注", 1);
        return;
      }
      const loc = {
        x: e.offsetX,
        y: e.offsetY,
      };
      this.polygon.push(loc);
      this.drawPolygon(this.polygon);
      this.isDrawing = true;
      this.isPointAdd = true;
    },

    // 选中删除多边形
    delpolygon() {
      const that = this;
      that.$confirm({
        title: "删除标注图形",
        content: "是否要删除这个标注图形？",
        okText: "是",
        cancelText: "否",
        onOk() {
          that.shapes.splice(that.selectIndex, 1);
          that.ctx.clearRect(0, 0, that.canvas.width, that.canvas.height);
          // that.showshapes();
          that.initmarkimg();
          if (!that.notkeepArr.includes(that.imgtext)) {
            that.notkeepArr.push(that.imgtext);
          }
        },
        onCancel() {
          that.ctx.clearRect(0, 0, that.canvas.width, that.canvas.height);
          that.initmarkimg();
          that.operaType = "none";
        },
      });
    },
    // 拖拽绘制出的顶点圆圈
    drawDot2(arr) {
      // this.ctx.arc(loc.x, loc.y, 0.5, 0, 2 * Math.PI);
      for (let i = 0; i < arr.length; i++) {
        this.ctx.beginPath();
        this.ctx.arc(
          arr[i].x / this.tempWidth,
          arr[i].y / this.tempHeight,
          4,
          0,
          2 * Math.PI
        );
        this.ctx.stroke();
        this.ctx.fillStyle = "red";
        this.ctx.fill();
      }
      this.dotstatus = 1;
    },
  },
  watch: {
    
  },
  beforeDestroy(){
    document.onkeydown = null
  },
  beforeRouterLeave(to, from, next) {
    next();
  },
};
</script>

<style lang="scss" scoped>
@import './index.scss'
</style>